/**
 * Single source of truth for the app version string displayed in the footer.
 *
 * Bump this every time you ship a meaningful set of changes (roughly the
 * same cadence as PRD entries). Semantic-ish: MAJOR for breaking model
 * changes, MINOR for new features, PATCH-in-the-string for bug fixes.
 */
export const APP_VERSION = "2.14";
